import { Card, CardAction, CardDescription, CardHeader, CardTitle } from '@repo/ui/card'
import { CardContent } from '@repo/ui/card'
import { useT } from '@repo/ui/hooks'
import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import Form from '@/components/admin/insights/edit/Form'
import { FormHandle, InsightsWidgetForm } from '@/components/admin/insights/edit/types'
import { ResetAndUpdate } from '@/components/ResetAndUpdate'
import { SkeletonCard } from '@/components/skeletons/SkeletonCard'
import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function InsightsEditRoute() {
  const [searchParams] = useSearchParams()
  const dispatch = useStoreDispatch()
  const { widget, loading } = useStoreState((state) => state.beneficiaryInsights)
  const { t } = useT({ keyPrefix: 'admin.insights.edit' })
  const formRef = useRef<FormHandle>(null)
  const [isFormValid, setIsFormValid] = useState(false)

  const widgetId = searchParams.get('id')

  useEffect(() => {
    if (!widgetId) return
    void dispatch(actions.getInsightWidget({ widgetId }))
  }, [widgetId])

  const updateWidget = (widget: InsightsWidgetForm) => {
    void dispatch(
      actions.updateInsightWidget({
        widgetId: widgetId!,
        widget: widget,
      }),
    )
  }

  return (
    <>
      <Card className="flex flex-1 flex-col overflow-hidden bg-opacity-20">
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('description')}</CardDescription>
          <CardAction>
            <ResetAndUpdate
              disabled={!isFormValid}
              onReset={() => formRef.current?.reset()}
              onUpdate={() => formRef.current?.submit()}
            />
          </CardAction>
        </CardHeader>
        <CardContent className="flex flex-1 flex-col gap-4 h-full overflow-y-auto">
          {loading && <SkeletonCard className="h-10 w-full" />}
          {!loading && widget && (
            <Form
              ref={formRef}
              widget={widget}
              onValidityChange={setIsFormValid}
              onSubmit={updateWidget}
            />
          )}
        </CardContent>
      </Card>
    </>
  )
}
